import React, { useState, useEffect } from "react";
import '../../../../../assets/css/bull_delete_column.css'
import useComponentVisible from "../../../../../utilities/hooks/useComponentVisible";
import { useDictionary } from "../../../../../utilities/hooks/UseDictionary";
import deleteIcon from '../../../../../assets/icons/ic_trash.svg';
import IconButton from "../../atom/IconButton";
import PropTypes from 'prop-types';
import { useExperienceSlotStatuses } from '../../../../../utilities/hooks/useExperienceSlotStatuses';
import { useExperienceSlotAccess } from '../../../../../utilities/hooks/useExperienceSlotAccess';
import moment from 'moment';
import fourCirclesIcon from "../../../../../assets/icons/ic_four_circles.svg";

const BulkDeletePopup = ({setBulkDeleteDialogVisibility,filterSlotParams,filterExperienceParams,calendarViewType,filterAccessParams}) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);
    const dictionary = useDictionary();
    const [experiences, setExperiences] = useState([]);
    const [slotStatus, setSlotStatus] = useState([]);
    const [filterAccess, setFilterAccess] = useState([]);
    const slotStatuses = useExperienceSlotStatuses();
    const asccessStatuses = useExperienceSlotAccess();
    

    const onSetDate = (dateInfo) => {
        const selectedMoment = moment(dateInfo.start);
        const type = dateInfo.type;
        let endDate;
    
        if (type === 'timeGridDay') {
            endDate = selectedMoment.clone().add(1, 'days');
            return `${selectedMoment.format('MMMM D, YYYY')}`;
        } else if (type === 'timeGridWeek') {
            endDate = selectedMoment.clone().add(6, 'days');
            return `${selectedMoment.format('MMMM D')} - ${endDate.format('D, YYYY')}`;
        } else if (type === 'dayGridMonth') {
            endDate = selectedMoment.clone().add(1, 'months');
            return `${selectedMoment.format('MMMM YYYY')}`;
        }
    };
    
    useEffect(() => {
        const loadedExperiences = JSON.parse(localStorage.getItem('calendar_filter_experience_list')) ?? [];
        const loadedSlotStatus = JSON.parse(localStorage.getItem('calendar_filter_slot')) ?? [];
        const loadedFilterAccess = JSON.parse(localStorage.getItem('calendar_filter_access')) ?? [];
        
        const selected_experiences = JSON.parse(localStorage.getItem('calendar_filter_experiences')) ?? [];
        const selected_status = Object.keys(slotStatuses).map((slotStatus) => {
            if (loadedSlotStatus.includes(slotStatus)) {
                return slotStatuses[slotStatus].text;
            }
        }).filter(text => text);
        const selected_filer_access = Object.keys(asccessStatuses).map((slotStatus) => {
            if (loadedFilterAccess.includes(slotStatus)) {
                return asccessStatuses[slotStatus].text;
            }
        }).filter(text => text);
        
        setExperiences(Object.values(loadedExperiences).filter(experience => selected_experiences.includes(experience.id)).map((e)=>e.text));
        setSlotStatus(selected_status);
        setFilterAccess(selected_filer_access);
    }, [filterExperienceParams,filterSlotParams,filterAccessParams]);

    const toggleDropdown = () => setIsComponentVisible(!isComponentVisible);

    const renderInfoData = (label, dataToRender) => {
        return dataToRender && dataToRender.length > 0 ?(
            <div className="info-item">
                <div className="info-item-label">{label}:</div>
                <div className="info-item-content">{dataToRender.join(', ')}</div>
            </div>
        ) : null
    }

    return (
        <div className="dropdown-container-columns buld_delete_dropdown" ref={ref}>
            <IconButton onClickIcon={toggleDropdown} activeState={isComponentVisible}>
                <div className="booking-column-list">
                    <img src={fourCirclesIcon} alt="Settings" />
                </div>
            </IconButton>

            {isComponentVisible && (
                <div className="dropdown-container-columns-section">
                    <div className="bd_dropdown-container-columns-section-scroll thin-scrollbar">
                        <div className="dropdown-manage-slots">
                            <p className="dropdown_title m-zero">{dictionary.selected_slots}</p>
                        </div>
                        <div className="info-container">
                            {renderInfoData(dictionary.dates, [onSetDate(calendarViewType)])}
                            {renderInfoData(dictionary.experience, experiences)}
                            {renderInfoData(dictionary.access, filterAccess)}
                            {renderInfoData(dictionary.slot_status, slotStatus)}
                        </div>
                    </div>
                    <div className="hr-line"></div>
                    <div className="dropdown-manage-slots dropdown_delete_button" onClick={()=>{setBulkDeleteDialogVisibility(true)}}>
                        <img src={deleteIcon} />
                        <div className="info-item-content">
                            {dictionary.delete_selected}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
BulkDeletePopup.propTypes = {
    setBulkDeleteDialogVisibility: PropTypes.func,
    filterExperienceParams: PropTypes.array,
    filterSlotParams: PropTypes.array,
}
export default BulkDeletePopup;
